import { appContext } from '../../../AppContext';
import IbssDialog from '../BaseDialog/IbssDialog';
import IbssButton from '../../Buttons/Button/IbssButton';
import { Box, Typography } from '@mui/material';
import { IbssComponent } from '../../Core/BaseComponent/IbssComponent';

class CancelEventAssociatedBookingsDialog extends IbssComponent<IProps, IState>
{
    private get labels(){ return appContext().labels; }
    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
        };
    }

    private async onSubmit(): Promise<void>
    {
        await this.props.updateBookings();
        this.props.onClose();
    }

    public render(): JSX.Element
    {
        return (
            <IbssDialog
                aria-modal="true"
                aria-label="cancel event associated booking warning modal"
                fullWidth
                maxWidth={'md'}
                open={this.props.show}
                onClose={this.props.onClose}
                header=
                {
                    <>
                        <label className="modal-heading">{this.labels.HubLabelModalConfirmTitle}</label>
                    </>
                }
                dialogContent=
                {
                    <Box>
                        <Typography>{this.labels.OneLens_BookingList_DeleteBookingWithEventPopupMessage}</Typography>
                    </Box>
                }
                footer=
                {
                    <div className='d-flex w-90' style={{ justifyContent: 'center', gap: '16px'}} >
                        <IbssButton
                            variant="contained"
                            color='secondary'
                            onClick={()=> this.props.onClose()}
                        >
                            {this.labels.Platform_IBSS_NoKeepItButton}
                        </IbssButton>
                        <IbssButton
                            variant="contained"
                            color='secondary'
                            onClick={()=> this.props.handleEventRoute()}
                        >
                            {this.labels.Flex_MyEvents_ManageEventsButton}
                        </IbssButton>
                        <IbssButton
                            variant={'contained'}
                            color={'error'}
                            onClick={() => this.onSubmit()}
                        >
                            {this.labels.funcBookingsYesProceed_S}
                        </IbssButton>
                    </div>
                }
            />
        )
    }
}

export default CancelEventAssociatedBookingsDialog;

export interface IProps
{
    show: boolean;
    onClose: ()=> void;
    updateBookings: ()=> Promise<void>;
    handleEventRoute: ()=> void;
}

export interface IState
{
}